export default {
  setTasks: (state, tasks) => {
    state.tasks = tasks;
  },

  setCurrentTask: (state, task) => {
    state.currentTask = { ...task };
  },

  setFilters: (state, filters) => {
    state.filters = filters;
  },

  setPaginationOptions: (state, paginationOptions) => {
    state.paginationOptions = paginationOptions;
  }
};
